import React, { ButtonHTMLAttributes } from 'react';
import { ButtonRegular as Button, ButtonSize, ButtonVariant, Modal as DSModal, ModalSize } from '@/components/shared';
import { ModalComponentProps } from './register';

interface ModalProps extends ModalComponentProps<ModalSize, ButtonVariant, ButtonSize> {
	readonly attributes: Omit<Partial<ButtonHTMLAttributes<never>>, 'color'>;
}

/**
 * CMS Modal component, used for showing CMS content in a modal
 */
export const Modal: React.FunctionComponent<ModalProps> = ({
	modalSize,
	children,
	buttonText,
	buttonVariant,
	buttonSize,
	attributes,
}) => {
	const [isOpen, setIsOpen] = React.useState(false);

	const handleOpen = React.useCallback((): void => {
		setIsOpen(true);
	}, []);

	const handleClose = React.useCallback((): void => {
		setIsOpen(false);
	}, []);

	return (
		<>
			<Button variant={buttonVariant} size={buttonSize} onClick={handleOpen} {...attributes} key={'modal'}>
				{buttonText}
			</Button>

			<DSModal open={isOpen} size={modalSize} onClose={handleClose}>
				{children}
			</DSModal>
		</>
	);
};
